/**
 * Converts a Salesforce ID to its 15-digit format.
 * Salesforce IDs can be either 15 or 18 characters long.
 * The 18-character version includes a 3-character checksum suffix.
 *
 * @param id - The Salesforce ID (15 or 18 characters)
 * @returns The 15-digit Salesforce ID
 */
export const to15DigitSalesforceId = (id: string): string => {
  if (!id) return '';

  // If already 15 characters or less, return as is
  if (id.length <= 15) return id;

  // If 18 characters, return the first 15
  if (id.length === 18) return id.substring(0, 15);

  // For any other length, return the first 15 characters
  return id.substring(0, 15);
};

/**
 * Checks if a record has a custom name by comparing the ID's 15-digit format with the name.
 * This is used to determine if a record has a custom name set or is using the default Salesforce ID.
 *
 * @param id - The Salesforce ID
 * @param name - The record name
 * @returns true if the record has a custom name, false if using default ID
 */
export const hasCustomName = (id: string, name: string): boolean => {
  if (!id || !name) return false;

  const id15Digit = to15DigitSalesforceId(id);
  return id15Digit !== name;
};
